import types from './types';
import labpackageActions from './labpackageActions';

const initState = {
    loader: false,
    labPackageData: [],
    limit: 10,
    skip: 0,
    count: 0
};

export default function labPackageReducer(state = initState, action, pageNum, search, filterby) {
    switch (action.type) {

        case types.GET_LAB_PACKAGE:
            return {
                ...state,
                loader: true,
                pageNum,
                search,
                filterby
            };

        case types.GET_LAB_PACKAGE_SUCCESS:
            return {
                ...state,
                loader: false,
                labPackageData: action.payload,
            };

        default:
            return state;
    }
}
